<template>
  <Navbar2 />

  <div class="breadcrumb-area services section-padding light-bg-1 pb-0">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-xl-10 col-lg-10 col-md-10 col-12 text-center">
          <div class="section-title">
            <p>Contact Us</p>
            <h2>Get in Touch with Afino Tax Consultants</h2>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Contact Page  -->
  <div class="contact-page section-padding light-bg-1">
    <div class="container">
      <div class="contact-page-inner white-bg">
        <div class="row">
          <div class="col-xl-6 col-lg-6 col-md-6">
            <div class="contact-form-wrapper">
              <h3>Send A Message</h3>
              <form @submit.prevent="handleSubmit" id="contactForm">
                <div v-if="formMessage" :class="['alert', formMessage.type === 'success' ? 'alert-success' : 'alert-danger']">
                  {{ formMessage.text }}
                </div>
                <input 
                  type="text" 
                  placeholder="Name" 
                  v-model="formData.name"
                  required
                  maxlength="100"
                />
                <input 
                  type="tel" 
                  placeholder="Phone" 
                  v-model="formData.contact"
                  required
                  maxlength="100"
                />
                <input 
                  type="email" 
                  placeholder="E-mail" 
                  v-model="formData.email"
                  required
                  maxlength="100"
                />
                <textarea
                  name="message"
                  id="message"
                  cols="30"
                  rows="10"
                  placeholder="Your Message"
                  v-model="formData.message"
                  required
                  maxlength="500"
                ></textarea>
                <input type="submit" value="Send A Message" :disabled="isSubmitting" />
              </form>
            </div>
          </div>
          <div class="col-xl-6 col-lg-6 col-md-6">
            <div class="contact-details-wrapper">
              <div class="section-title">
                <p>QUICK CONTACT</p>
                <h2>Have Questions? Get in Touch!</h2>
              </div>
              <p>
                We're here to help you with all your tax and accounting needs. 
                Contact us today to discuss how we can support your business in Dubai, UAE.
              </p>
              <div class="contact-details">
                <div class="single-contact-info">
                  <div class="contact-icon">
                    <i class="las la-phone-volume"></i>
                  </div>
                  <div class="contact-info">
                    <p>Have any question?</p>
                    <h5>Free {{ contact.phone }}</h5>
                  </div>
                </div>
                <div class="single-contact-info">
                  <div class="contact-icon">
                    <i class="las la-envelope-open"></i>
                  </div>
                  <div class="contact-info">
                    <p>Write email</p>
                    <h5>{{ contact.mail }}</h5>
                    <h5 style="margin-top: 8px; font-size: 18px;">consulting@afinotax.com</h5>
                  </div>
                </div>
                <div class="single-contact-info">
                  <div class="contact-icon">
                    <i class="las la-phone-volume"></i>
                  </div>
                  <div class="contact-info">
                    <p>Visit anytime</p>
                    <h5>{{ contact.address }}</h5>
                  </div>
                </div>
                <div class="single-contact-info">
                  <div class="contact-icon">
                    <i class="las la-share-alt"></i>
                  </div>
                  <div class="contact-info">
                    <p>Follow us</p>
                    <div class="contact-social-icons-group">
                      <a href="https://www.instagram.com/afino.tax?igsh=MTVyaXllOXNvOW92cA%3D%3D&utm_source=qr" target="_blank" rel="noopener noreferrer" class="contact-social-icon-btn" aria-label="Follow us on Instagram">
                        <i class="lab la-instagram"></i>
                      </a>
                      <a href="https://www.linkedin.com/company/afino-tax-consultant/" target="_blank" rel="noopener noreferrer" class="contact-social-icon-btn" aria-label="Follow us on LinkedIn">
                        <i class="lab la-linkedin"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Google Map Start-->
  <div class="contact-page google-map">
    <iframe
      src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d875.0863368296174!2d55.452011718132454!3d25.41911039999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjXCsDI1JzA4LjgiTiA1NcKwMjcnMDkuOSJF!5e1!3m2!1sen!2sae!4v1762277280725!5m2!1sen!2sae"
      width="600"
      height="600"
      style="border: 0"
      allowfullscreen=""
      loading="lazy"
      referrerpolicy="no-referrer-when-downgrade"
    ></iframe>
  </div>

  <ContactComponent />
  <Footer2 />
</template>

<script>
import ContactComponent from "@/components/ContactComponent.vue";
import Navbar2 from "@/components/Navbar2.vue";
import Footer2 from "@/components/Footer2.vue";
import axios from "axios";
export default {
  name: "Contact",
  components: { Navbar2, Footer2, ContactComponent },
  data() {
    return {
      contact: [],
      formData: {
        name: '',
        email: '',
        contact: '',
        message: '',
      },
      formMessage: null,
      isSubmitting: false,
    };
  },
  async beforeMount() {
    let fetchedData = await axios.get("/assets/data/contact.json");
    this.contact = fetchedData.data.contact;
  },
  methods: {
    async handleSubmit() {
      if (!this.formData.name || !this.formData.email || !this.formData.contact || !this.formData.message) {
        this.formMessage = { type: 'error', text: 'All fields are required!' };
        return;
      }

      // Email validation
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(this.formData.email)) {
        this.formMessage = { type: 'error', text: 'Please provide a valid email!' };
        return;
      }

      this.isSubmitting = true;
      this.formMessage = null;

      try {
        let formData = new FormData();
        formData.append("Name", this.formData.name);
        formData.append("Email", this.formData.email);
        formData.append("Phone", this.formData.contact);
        formData.append("Contact", this.formData.message);

        const response = await fetch(
          "https://script.google.com/macros/s/AKfycbwC1pfWpoIi9_gRINZA1UEhKMaas9JhlNo5L1q3DVO0ktELh5l-XcFNsQiKLHSjY5nd/exec",
          {
            method: "POST",
            body: formData,
          }
        );

        if (response.status === 200) {
          this.formMessage = { type: 'success', text: 'Message sent successfully!' };
          this.formData = {
            name: '',
            email: '',
            contact: '',
            message: '',
          };
        } else {
          this.formMessage = { type: 'error', text: 'Failed to send message. Please try again.' };
        }
      } catch (error) {
        this.formMessage = { type: 'error', text: error?.message || 'An error occurred. Please try again.' };
      } finally {
        this.isSubmitting = false;
      }
    },
    addStructuredData() {
      // ContactPage structured data
      const contactPageData = {
        "@context": "https://schema.org",
        "@type": "ContactPage",
        "name": "Contact Us - Afino Tax Consultants",
        "description": "Get in touch with Afino Tax Consultants in Dubai, UAE. Expert tax and accounting services.",
        "url": "https://www.afinotax.com/contact",
        "mainEntity": {
          "@type": "Organization",
          "name": "Afino Tax Consultants",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "W8 building, 5th floor, DAFZA",
            "addressLocality": "Dubai",
            "addressRegion": "Dubai",
            "addressCountry": "AE"
          },
          "telephone": "+971-54-566-8994",
          "email": "sales@afinotax.com",
          "contactPoint": {
            "@type": "ContactPoint",
            "telephone": "+971-54-566-8994",
            "contactType": "customer service",
            "email": "sales@afinotax.com",
            "areaServed": "AE",
            "availableLanguage": ["English", "Arabic"]
          }
        }
      };

      const script = document.createElement('script');
      script.id = 'structured-data-contact';
      script.type = 'application/ld+json';
      script.textContent = JSON.stringify(contactPageData);
      document.head.appendChild(script);
    }
  },
  beforeUnmount() {
    const script = document.getElementById('structured-data-contact');
    if (script) script.remove();
  },
};
</script>

<style scoped>
.contact-social-icons-group {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 10px;
}

.contact-social-icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  background-color: #f5f5f5;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  color: #056251;
  font-size: 20px;
  text-decoration: none;
  transition: all 0.3s ease;
  cursor: pointer;
}

.contact-social-icon-btn:hover {
  background-color: #056251;
  border-color: #056251;
  color: #ffffff;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(5, 98, 81, 0.3);
}

.contact-social-icon-btn i {
  display: flex;
  align-items: center;
  justify-content: center;
}

@media (max-width: 767px) {
  .contact-social-icon-btn {
    width: 38px;
    height: 38px;
    font-size: 18px;
  }
}
</style>
